<template>
    <div>
        <el-form label-width="70px" :label-position="'right'">
            <el-form-item label="折扣">
                <el-input-number v-model="$parentInfo.studentCart.dialog_DiscountShop.discountFilter.discount"
                                 size="medium" type="number"
                                 :min="1" :max="10" :step="0.5"></el-input-number>
            </el-form-item>
            <el-form-item label="折扣原因">
                <el-input v-model="$parentInfo.studentCart.dialog_DiscountShop.discountFilter.discount_reason" size="small"
                          type="textarea"></el-input>
            </el-form-item>
        </el-form>
        <div class=" text-right">
            <el-button type="primary" size="small" @click="handleChangeDiscount()"
                       :loading="$parentInfo.studentCart.dialog_DiscountShop.button_loading">确 定
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            //优惠
            handleChangeDiscount() {
                this.$parentInfo.studentCart.dialog_DiscountShop.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'get_discount_to_cart_shop', {
                    'cart_shop_id': this.$store.state.modal.data.cart_shop_id,
                    'discount': this.$parentInfo.studentCart.dialog_DiscountShop.discountFilter.discount,
                });
            },
        }
    };
</script>

<style scoped>
</style>
